import { createFileRoute } from "@tanstack/react-router";
import DiagnosedDepressionAt30 from "@/pages/articles/DiagnosedDepressionAt30";
export const Route = createFileRoute("/diagnosed-with-depression-at-30")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Diagnosed With Depression At 30 | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Depression at 30 can derail career and family life. Learn about TMS, SAINT TMS, and treatment options for adults in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Diagnosed With Depression At 30 | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Depression at 30 can derail career and family life. Learn about TMS, SAINT TMS, and treatment options for adults in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/diagnosed-with-depression-at-30",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/diagnosed-with-depression-at-30",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DiagnosedDepressionAt30 />;
}
